/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CurrencyInputs */

const en_common_currency = /** @type {(inputs: Common_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {Common_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_currency = /** @type {((inputs?: Common_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_currency(inputs)
});